"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonPageTWCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
class CommonPageTWCard extends react_1.Component {
    constructor() {
        super(...arguments);
        this.appStoreIdStr = '1498607143';
        this.googlePlayIdStr = 'com.bd.nproject';
    }
    render() {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("meta", { name: "twitter:app:id:iphone", content: this.appStoreIdStr }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:app:id:googleplay", content: this.googlePlayIdStr }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:card", content: "summary_large_image" }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:site", content: "@Lemon8" }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:title", content: this.props.twCardTitle }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:description", content: this.props.twCardDesc }), (0, jsx_runtime_1.jsx)("meta", { name: "twitter:image", content: this.props.twCardImageSrc })] }));
    }
}
exports.CommonPageTWCard = CommonPageTWCard;
